import { render, staticRenderFns } from "./serviceIndex.vue?vue&type=template&id=08a1ba8a&scoped=true&"
import script from "./serviceIndex.vue?vue&type=script&lang=js&"
export * from "./serviceIndex.vue?vue&type=script&lang=js&"
import style0 from "./serviceIndex.vue?vue&type=style&index=0&id=08a1ba8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1ba8a",
  null
  
)

export default component.exports